import moment from 'moment';
import { t, i18n } from 'i18next';
import { useNavigate } from 'react-router-dom';

import styles from './RecentJobs.module.css';
import {
    ExclusiveJobIcon,
    TopRightArrow,
} from '../../../../../../assets/images/icons';
import { useSelector } from 'react-redux';
import { getTimeAgo } from '../../../../../../utils/formatHelpers';

function RecentJobs({ title, job }) {
    const language = useSelector((state) => state.translation.language);

    const profileDataUI = (icon, title, desc, removeBorder, slug) => {
        return (
            <div className={removeBorder ? `${styles.profileDataContainer} ${styles.removeBorder}` : `${styles.profileDataContainer}`} style={{ width: "100%" }}>
                <div className={styles.featureContentContainer}>
                    <div className={styles.dataIconContainer}>
                        <p onClick={() => {
                            navigate(`/jobs/${slug}`);
                        }} className={styles.profileDataTitle}
                            style={{ cursor: "pointer" }}
                        >{title}</p>

                        {icon && <img src={icon} alt={`profile data icon`} className={styles.profileDataIcon} />}
                    </div>
                </div>
                <div className={styles.col}>
                    {desc !== 'login_test' && <p className={styles.profileDataValue}>{desc}</p>}
                </div>
            </div>
        );
    };

    const navigate = useNavigate();
    const jobList = job?.length > 5 ? job?.slice(0, 5) : job
    return (
        <div className={styles.container}>
            <h5 className={styles.jobTitle}>{title}</h5>
            {job?.length > 0 && jobList?.map((item, index) => {
                let last_seen = '';
                const timeAgo = getTimeAgo(new Date(item.createdAt));
                if (timeAgo.unit_plural !== 'month' && timeAgo.unit_plural !== 'months' && timeAgo.unit_plural !== 'year' && timeAgo.unit_plural !== 'years') {
                    if (timeAgo.unit_plural === 'second' || timeAgo.unit_plural === 'seconds' || timeAgo.unit_plural === 'minute' || (timeAgo.unit_plural === 'minutes' && timeAgo.count < 5)) {
                        last_seen = timeAgo.count + ' ' + t('general.UI.' + timeAgo.unit_plural) + ' ' + t('general.UI.ago');
                    }
                    else {
                        last_seen = timeAgo.count + ' ' + t('general.UI.' + timeAgo.unit_plural) + ' ' + t('general.UI.ago');
                    }
                }
                return (profileDataUI(item.exlusiveJob && ExclusiveJobIcon, item.title, last_seen, index == jobList?.length - 1 ? true : false, item.slug));
            })}
            <div onClick={() => {
                navigate('/jobs', { state: { job } });
            }} className={styles.seeAllButtonContainer}>

                <p className={styles.seeAllButton}>{t(`see_all_jobs`)}</p>
                <img src={TopRightArrow} alt="arrow icon" className={styles.arrowIcon} />

            </div>

        </div>
    );
}

export default RecentJobs;
